!function(module){
	if(window.define) define('hotels/hotelAutoCompleteResponse',['hotelBackgroundSearch'], module)
	else module(CT.hotelBackgroundSearch)
}(function(hotelBackgroundSearch){
if(CT.app == 'dp') {
	window.responseModifierHotel = function responseModifierHotel(data){
		var temp=[];
		var i=0;
		$(data).each(function(index,ele){

			temp[i]={};
			$.extend(temp[i],ele);
			if(ele.ty !==undefined){
				if(ele.ty==="c" && ele.tp==="1"){
					temp[i].category="Best match";
				}
				else if(ele.ty==="a" && ele.tp==="1"){
					temp[i].category="Top pick areas";
				}
				else if(ele.ty==="c"){
					temp[i].category="Cities";
				}else if(ele.ty==="a"){
					temp[i].category="Areas";
				}
				else if(ele.ty==="h"){
					temp[i].category="Hotels";
				}
				else if(ele.ty==="p"){
					temp[i].category="Point of Interest"
				}
				else if(ele.ty==="nr"){
					temp[i].category="Not Found";
				}

			}
			if(ele.ty==="nr"){
				desc="";
			}
			else{
				var desc=ele.sc;
				if(ele.cya !==undefined){
					desc=ele.cya +" "+desc;
				}else{
					desc=ele.cy +" "+desc;
				}
				if(ele.ty !=="c"){
					desc=ele.n +", "+desc;
				}
			}

			temp[i]["des"]=desc;
			temp[i]["label"]=desc;
			temp[i]["value"]=ele.k;
			i++;
		});
		return temp;
	}
	window.hotelSelectionHandler  = function hotelSelectionHandler(e,ui){

		$(e.target.parentNode).find("#State").val(ui.item.s);
		$(e.target.parentNode).find("#Country").val(ui.item.c);
		if(ui.item.n !==undefined){
			$(e.target.parentNode).find("#AreaName").val(ui.item.n)
		}
		else{
			$(e.target.parentNode).find("#AreaName").val('');
		}
		$(e.target.parentNode).find("#City").val(ui.item.cy);
		if(ui.item.hid !==undefined){
			$(e.target.parentNode).find("#HotelId").val(ui.item.hid);
		}
		else{
			$(e.target.parentNode).find("#HotelId").val('');
		}
		
	}
} else {
	window.responseModifierHotel = function responseModifierHotel(data, refTag){
		CT.utils.trackers.eventData.searchedString = refTag.value;	
		window.isTagAutocomplete=0	
		var temp=[],locRank=0,poiRank=0,poeRank=0,
		data = (data.r) ? data.r : data,
		i=0, tmp, $inputTag = $(refTag);
		if(data && data.length && data[0].tg && data[0].tg.length && window.enableTagAutocomplete == "true" ){
			window.isTagAutocomplete=1;
		}
		$(data).each(function(index,ele){
			if((ele.ty!=='a' && ele.ty!=='p') || !window.isTagAutocomplete){
			temp[i]={};
			$.extend(temp[i],ele);
			if(ele.ty !==undefined){
				if(ele.ty === "g"){
					temp[i].category=CT.messages.hotel.Gateways;
				}
				else if(ele.ty==="c" && ele.tp==="1"){
					temp[i].category=CT.messages.hotel.Tophit;
				}
				else if((ele.ty==="a" && ele.tp==="1") || (ele.ty==="p" && ele.tp==="1")){
					temp[i].category=CT.messages.hotel.BestOf + ele.cy;
					temp[i].cls="child";
				}
				else if(ele.ty==="c"){
					temp[i].category=CT.messages.hotel.Cities;
				}else if(ele.ty==="a" || ele.ty==="p"){
					temp[i].category=CT.messages.hotel.Locations;
				}
				else if(ele.ty==="h"){
					temp[i].category=CT.messages.hotel.Hotels;
				}
				else if(ele.ty==="nr"){
					temp[i].category=CT.messages.hotel.NotFound;
				}
				
			}
			if(ele.ty==="nr"){
				desc="";
					} else if(ele.ty =="sug") { //Do you mean
						desc= ele.name;
					}else if(ele.ty === "g"){
						desc = CT.messages.hotel.WKGFrom +ele.cy
					} else{
						if((tmp = $inputTag.attr('data-optionstext'))) {
							var desc=ele[tmp];
						}
						else {
							var desc=ele.sc;
							if(ele.cya !==undefined){
								desc=ele.cya +", "+desc;
							}else{
								desc=ele.cy +", "+desc;
							}
							
							if(ele.ty !=="c"){
								if(ele.ty=='a' && ele.tp==1){
									temp[i]["rank"]=++locRank;
									temp[i]['placetype']="locality";
									temp[i]["place"]=ele.n;
									desc=" "+ele.n+" "+(ele.z?"<small>"+(ele.z=="0"?"</small>":ele.z+" hotels</small>"):'');
								}
								else if(ele.ty=='p' && ele.tp==="1")
								{	
									if(ele.st=='f'){
									 temp[i]["rank"]=++poeRank;
									 temp[i]["placetype"]="entryPoint";
									 temp[i]["place"]=ele.n;	
									 desc="Near airport ("+ele.n+") "+(ele.z?"<small>"+(ele.z=="0"?"</small>":ele.z+" hotels</small>"):'');
									}
									else if(ele.st=='r'){
									 temp[i]["rank"]=++poeRank;	
									 temp[i]["placetype"]="entryPoint";
									 temp[i]["place"]=ele.n; 
									 desc="Near Railway Station ("+ele.n+") "+(ele.z?"<small>"+(ele.z=="0"?"</small>":ele.z+" hotels</small>"):'');
									}
									else{
									 temp[i]["rank"]=++poiRank;
									 temp[i]["placetype"]="pointOfInterest";
									 temp[i]["place"]=ele.n;	
									 desc=" "+ele.n+" "+(ele.z?"<small>"+(ele.z=="0"?"</small>":ele.z+" hotels</small>"):'');
									}
							     }
								else 
									desc=ele.n+", "+desc;
							}
						}
					}
					if($inputTag.attr("data-trauncate") && $inputTag.attr("data-trauncate") == "true"){
						if(desc.length > 32){
							desc = desc.substr(0, 34) + '...'
						}
					}
					temp[i]["des"]=desc;
					temp[i]["label"]=desc;
					temp[i]["value"]= (ele.k) ? ele.k : '';
					if(i == 0 && ele.tg){
						i++;
						(ele.tg).forEach(function(tag){
							temp[i]={};
							temp[i]["des"]=tag.tagName;
							temp[i]["label"]=tag.tagName;
							temp[i]["category"]=CT.messages.hotel.Tophit;
							temp[i]["value"]= (ele.k) ? ele.k : '';
							temp[i]["cls"]="child";
							temp[i]["n"]=tag.tagName;
							temp[i]["tgKey"]=tag.tagId;
							temp[i]["cy"]=ele.cy;
							temp[i]["c"]=ele.c;
							temp[i]["s"]=ele.s;
							temp[i]["k"]=ele.k;
							temp[i]["sc"]=ele.sc;
							temp[i]["ty"]='a';

							i++;
						});
						i--;
					}
					i++;				}
				});				
	if(CT.subProd == "wg"){
		gatewayAutoSuggest(temp,'updatedCities',true);
	}
	return temp;	
	}
	function gatewayAutoSuggest(items,toUpdateOptGroup,toUpdate){
		//$('.chzn-select #'+toUpdateOptGroup).html("");
		
		$(items).each(function(index,ele){
			if(ele.ty !==undefined){
				if(!$('.chzn-select').find('option[value="' + ele.cy + '"]').length){
					var eleOpt = new Option(ele.cy, ele.cy)
					$(eleOpt).attr("data-ui",JSON.stringify(ele));
					$('.chzn-select #'+toUpdateOptGroup).append(eleOpt);
					
				}
			}
		})
		if(toUpdate == true){
			$('.chzn-select').trigger("chosen:updated");
		}
	}
	window.hotelSelectionHandler = function hotelSelectionHandler(e,ui){
		// On hotel selection remove the disable attribute from search form submit button, only works for B2B
		$("#SearchHotelsButton").removeAttr('disabled');
		var ele = ui.item?ui.item:ui;
		$target = (e.currentTarget) ? $(e.target) : e;
		$parent = $target.parent();
		$target.removeAttr("rank placetype")
		$target.attr({"category":ele.category,"locationSelected":ele.place?ele.place:ele.des});
		if(ele.rank && ele.placetype)
			$target.attr({"rank":ele.rank,"placetype":ele.placetype});
		$parent.find("#State").val(ele.s);
		$parent.find("#Country").val(ele.c);
		
		if(ele.ty == 'a' && window.treatAreaAsPoi == "false"){
			if(window.isTagAutocomplete){
				$parent.find("#Area").val('');
				$parent.find("#Poi").val('');
				CT.utils.trackers.eventData.categorySelected = "Tags";
				$parent.find("#SearchTag").val(ele.tgKey);
			}
			else{
				$parent.find("#Area").val(ele.n);
				$parent.find("#Poi").val('');
				CT.utils.trackers.eventData.categorySelected = "Area";
			}
		}
		else if(ele.ty == 'p' || (ele.ty == 'a' && window.treatAreaAsPoi == "true")){
			
			$parent.find("#Poi").val(ele.n)
			$parent.find("#Area").val('');
			if(ele.ty == 'a'){
                CT.utils.trackers.eventData.categorySelected = "Area";

            }else{
                CT.utils.trackers.eventData.categorySelected = "POI";
            }
		}
		else if(ele.ty == 'h'){
			$parent.find("#Area").val('');
			$parent.find("#Poi").val('');
			CT.utils.trackers.eventData.categorySelected = "Hotel";
		}
		else if(ele.ty == 'c'){
			$parent.find("#Area").val('');
			$parent.find("#Poi").val('');
			CT.utils.trackers.eventData.categorySelected = "City";
		}
		else if(ele.ty == 'f'){
			$parent.find("#Area").val('');
			$parent.find("#Poi").val('');
			CT.utils.trackers.eventData.categorySelected = "Entry Point";
		}

		$parent.find("#City").val(ele.cy);

		if(ele.category == CT.messages.hotel.Hotels){
			
			if(ui.item.hid !==undefined){
				$parent.find("#HotelId").val(ui.item.hid);
			}
			
			$parent.find("#HotelName").val(ele.n);
		}
		else{
			$parent.find("#HotelId").val('');
			$parent.find("#HotelName").val('');
		}
		if(CT.subProd == "wg"){
			$("#wgSelectChoosen").val(ele.cy)
			$('.chzn-select').trigger("chosen:close");
		}
		if(window.enableHotelsBackgroundSearch){
			hotelBackgroundSearch.getHotelContent({city:ele.cy, state:ele.s, country:ele.c});
			hotelBackgroundSearch.getCityImages({city:ele.cy, state:ele.s, country:ele.c})
		}
		else {
			if($target[0].hotelContentBgSearch && CT.subProd != "wg" && ele.category != CT.messages.hotel.Hotels){
				var hotelContentBgSearch = $target[0].hotelContentBgSearch;
				hotelContentBgSearch.set({city:ele.cy, state:ele.s, country:ele.c}, null,function(content){
					//	CT.utils.helperFunctions.prefetchCityImages($target[0] , {city:ele.cy, state:ele.s, country:ele.c});
				});
			}
			
			if($target[0].cityImagesBgSearch && CT.subProd != "wg" && ele.category != CT.messages.hotel.Hotels){
				var cityImagesBgSearch = $target[0].cityImagesBgSearch;
				cityImagesBgSearch.set({city:ele.cy, state:ele.s, country:ele.c},function(data){
					//CT.utils.helperFunctions.prefetchCityImages($target[0] , {city:ele.cy, state:ele.s, country:ele.c});
				});	
			}
		}
		/////////////////////////// HACKER ///////////////////////////
		//ele.cy
		//ele.k
		/*if(CT.utils.cookies.read("userid")){
			$.ajax("/getUserHistory?city_id="+ ele.k +"&user_id="+unescape(CT.utils.cookies.read("userid")).split("|")[0]).done(function(data){
				var data = {loc:[{id:123,name:"MG Road"}],star:3}
				
				window.CTHACKSTORE = {};
				window.CTHACKSTORE = data;
				
			});
			var data = {loc:[{id:123,name:"MG Road"}],star:3}
			window.CTHACKSTORE = {};
			window.CTHACKSTORE = data;
		}*/
		
		
		/////////////////////////// HACKER ///////////////////////////
		if(!window.isMobileUA){
			// On selecting where(hotel, city etc) from auto complete, start from date selection
			$target.closest('form').find("input.checkin_date").focus()
		}
		var category = "Hotels_TS", action = "H_Search_Where", label = ('City=' + $target.val() + ',Category='+ele.category);
		if(!window.locationCounter)
			window.locationCounter=0;
		if($("body").is(".srp")){
			category = "Hotels_TR";
			action = "H_Modify_Where";
			window.locationCounter=0;
		}
		CT.utils.helperFunctions.trackGAEventWrapper(category, action, label, '100');
		//Mixpanel Tracker for Autocomplete Selection
		
		var locationSelected=ui.item.des;
		var categorySelected=ui.item.category;
		window.locationCounter++;
		CT.utils.trackers.mixpanelTrackingData.destinationCity = locationSelected ? locationSelected:"N/A";
		CT.utils.trackers.eventData.destinationCity = locationSelected ? locationSelected:"N/A";
		CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Home_searchbar_selectItem", {
			"destinationCity": locationSelected ? locationSelected:"N/A",
			"destinationCountry": locationSelected ? (locationSelected.split(',')[2] ? locationSelected.split(',')[2] : "N/A" ) : "N/A",
			"searchType": categorySelected,
			"searchedItem": String(CT.utils.trackers.eventData.searchedString),
			"lenSearchedItem":String(CT.utils.trackers.eventData.searchedString.length),
			"searchCategorySelected": CT.utils.trackers.eventData.categorySelected
		});

	}
}
}, CT);

